import { Column } from 'app/design/primitives/box';
import React from 'react';
import { View } from 'react-native';
import { theme } from './shared';

export function ProfileStatsAndReport({ emojiStatsElements }: { emojiStatsElements: (React.ReactElement | null)[] }) {
  if (!emojiStatsElements.some(Boolean)) return null;
  return (
    <Column style={{ marginTop: theme.spacing['spacing.general.x5'] }}>
      <View style={{ flexWrap: 'wrap', flexDirection: 'row' }}>
        {emojiStatsElements.map((element) => (
          <View
            key={element?.key ?? 'requests-placeholder'}
            style={{
              flexBasis: '50%',
              marginBottom: theme.spacing['spacing.general.x3'],
              paddingHorizontal: theme.spacing['spacing.general.x2'],
            }}
          >
            {element}
          </View>
        ))}
      </View>
    </Column>
  );
}
